import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType, Field, FormlyFieldConfig } from '@ngx-formly/core';

import { MessageService } from '@app/shared/services/message.service';
import { QuestionnaireService } from '@app/shared/services/questionnaire.service';

import { environment } from '@environment/environment';
import { MatDialog } from '@angular/material/dialog';

import { ResponsibilitiesListDialogComponent } from '@app/features/questionnaires/questionnaire/dialogs/responsibilities-list-dialog/responsibilities-list-dialog.component';

@Component({
  selector: 'db-custom-field-responsibility-list',
  templateUrl: './custom-field-responsibility-list.component.html',
  styleUrls: ['./custom-field-responsibility-list.component.scss']
})
export class CustomFieldResponsibilityListComponent extends FieldType implements OnInit, OnDestroy {
  displayModel: [];
  responsibilitiesDropdownList: any[] = [];
  responsibilitiesDropdownSettings = {};
  private valueSub: any;

  constructor(
    private _messageService: MessageService,
    private _questionnaireService: QuestionnaireService,
    private _dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeDropdown();

    if (this.formControl && this.formControl.value) {
      this.displayModel = this.formControl.value?.responsibleRoles || [];
    } else {
      this.displayModel = [];
    }

    if (this.formControl) {
      this.valueSub = this.formControl.valueChanges.subscribe(val => {
        const roles = val?.responsibleRoles || [];
        this.displayModel = roles;

        if (val && Array.isArray(roles)) {
          this.responsibilitiesDropdownList = roles;
        }
      });
    }
  }

  deleteField(field: FormlyFieldConfig) {
    this._messageService.sendMessage('delete:' + field.id);
  }

  editField(field: FormlyFieldConfig): void {
    this._messageService.sendMessage(field.key as string);
  }

  getSector(id: string): string {
    return this._questionnaireService.getSector(id);
  }

  editResponsibilitiesListDialog(): void {
    this._dialog.open(ResponsibilitiesListDialogComponent, {
      width: '930px',
      panelClass: 'db-dialog',
      data: {
        model: this.model,
        field: this.field
      }
    }).afterClosed().subscribe(data => {
      if (data) {
        this.model = data;

        this.formControl.setValue(this.model[this.field.key as string]);

        this.form.markAsDirty();

        this.initializeDropdown();
      }
    });
  }

  showSector(): boolean {
    return environment.showSectors;
  }

  private initializeDropdown(): void {
    this.responsibilitiesDropdownSettings = {
      idField: 'id',
      textField: 'name',
      singleSelection: true,
      itemsShowLimit: 1
    };

    const fieldValue = this.model ? this.model[this.field.key as string] : null;
    this.responsibilitiesDropdownList = Array.isArray(fieldValue?.responsibleRoles)
      ? fieldValue.responsibleRoles
      : [];
  }

  ngOnDestroy(): void {
    if (this.valueSub) {
      this.valueSub.unsubscribe();
    }
  }
}
